import { defineColumn, type StrictColumnDef } from '../../../../components/tanstack-table/column';
import { formatPercent } from '../../../../helpers/format-currency';
import type { ProductOrderItem } from '../data/product-order-item';

function computeOutOfStockRisk(item: ProductOrderItem): number {
  const { product } = item;
  const projected = product.stats.last_year_next_30;
  if (projected <= 0) {
    return 0;
  }

  const qoh = Math.max(0, product.inventory_qty);

  return Math.max(0, projected - qoh) / projected;
}

export const OutOfStockRisk: StrictColumnDef<ProductOrderItem> = {
  ...defineColumn<ProductOrderItem>({
    id: 'Out of Stock Risk',
    minWidth: 60,
    accessorFn: (item) => formatPercent(computeOutOfStockRisk(item)),
    sortKeyFn: computeOutOfStockRisk,
    gloss:
      "Percentage of projected 30-day demand that can't be filled with current stock, based on same-period sales last year",
  }),
  // The displayed header stays abbreviated; the column id is the long, unabbreviated name.
  header: 'OOS Risk',
};
